import React from 'react';
import * as PropTypes from 'prop-types';

import { Link } from '../../router';
import { classNamer, classes } from '../../lib/utils';
import Details from './Details';

import './Navigation.scss';

const cn = classNamer('Navigation');

const renderArticle = (item, dynamicRoute) => {
  return (
    <div className={cn('item')}>
      <Link route={dynamicRoute(item)}>
        <a className={cn('title')}>{item.title}</a>
      </Link>

      <Details item={item} />
    </div>
  );
};

const Navigation = ({ className, prev, next, children, dynamicRoute }) => {
  return (
    <div className={classes(cn(), className)}>
      <div className={cn('prev')}>
        {prev && (
          <>
            <div className={cn('arrow')} />
            {renderArticle(prev, dynamicRoute)}
          </>
        )}
      </div>

      <div className={cn('top')}>
        <div className={cn('top', 'holder')}>
          <div className={cn('arrow')} />
        </div>
        {children}
      </div>

      <div className={cn('next')}>
        {next && (
          <>
            {renderArticle(next, dynamicRoute)}
            <div className={cn('arrow')} />
          </>
        )}
      </div>
    </div>
  );
};

Navigation.propTypes = {
  prev: PropTypes.object,
  next: PropTypes.object,
  dynamicRoute: PropTypes.func.isRequired,
};

export default Navigation;
